export const login = {
  texts: {
    signIn: 'Autentificare',
    enterUsername: 'Nume utilizator',
    enterPassword: 'Parola',
    rememberMe: 'Ține-mă minte',
    btnSignInWorking: 'Așteaptă...',
    btnSignInWithActiveDirectory: 'Autentifică-te cu Active Directory',
    btnSignIn: 'Autentifică-te',
    usernameLabel: 'Utilizator:',
    passwordLabel: 'Parola:',
    errUsernameRequired: 'Un utilizator valid este necesar',
    errPasswordRequired: 'Parola este necesară'
  },
  toasts: {
    welcomeBackMessage: 'Bine ai revenit!',
    welcomeBackTitle: 'Autentificare reușită',
    invalidCredentialsMessage: 'Datele de autentificare sunt incorecte!',
    invalidCredentialsTitle: 'Eroare la autentificare'
  }
}
